import React from 'react';
import { motion } from 'framer-motion';
const painPoints = ['Sientes que tu cuerpo cambió y no sabes cómo explicarlo.', 'Te sientes inflamada, cansada y con muy poca energía durante el día.', 'Duermes mal o te despiertas varias veces en la noche.', 'Te miras al espejo y no te reconoces como antes.', 'Vives en dieta constante y aun así te sientes inflamada y frustrada.'];
export function PainSection() {
  return <section className="bg-warm-white pt-4 pb-16 md:py-24 px-4" data-id="element-192">
      <div className="max-w-3xl mx-auto" data-id="element-193">
        {/* Intro text block */}
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-194">
          <p className="text-lg md:text-xl font-heading font-semibold text-olive leading-snug" data-id="element-195">
            Si no duermes bien...tu cuerpo no puede desinflamarse.
          </p>
          <p className="text-base md:text-lg text-warm-gray mt-2 leading-snug" data-id="element-196">
            Este ebook incluye un módulo especial donde aprenderás cómo comenzar
            a regular tu sueño desde la raíz.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-197">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-olive" data-id="element-198">
            ¿Te está pasando esto después de los 40?
          </h2>
        </motion.div>

        <div className="space-y-4 mb-12" data-id="element-199">
          {painPoints.map((point, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="flex items-start gap-4 bg-white p-5 rounded-2xl shadow-card" data-id="element-200">
              <div className="mt-1.5 w-3 h-3 rounded-full bg-warm-accent flex-shrink-0" data-id="element-201" />
              <p className="text-olive font-medium text-lg" data-id="element-202">{point}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5
      }} className="text-center space-y-2 bg-cream p-8 rounded-2xl border border-sage/20" data-id="element-203">
          <p className="text-xl md:text-2xl font-bold text-olive font-heading" data-id="element-204">
            No es falta de fuerza de voluntad.
          </p>
          <p className="text-lg md:text-xl font-bold text-sage" data-id="element-205">
            Son cambios hormonales reales que casi nadie te explicó.
          </p>
        </motion.div>
      </div>
    </section>;
}